import { Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import React, { ReactNode } from "react";
export interface PlaceholderComponent {
  type: "link" | "image" | "custom";
  props?: any;
  content?: string;
}

export interface PlaceholderConfig {
  [key: string]: PlaceholderComponent;
}

function buildLinkComponent(config: PlaceholderComponent): ReactNode {
  return (
    <Link
      href={config.props?.href}
      target={config.props?.target || "_blank"}
      rel="noopener noreferrer"
      touchpoint={config.props.touchpoint}
      style={config.props?.fontWeight ? { fontWeight: config.props.fontWeight } : undefined}
    >
      {config.content || config.props?.text || "link"}
    </Link>
  );
}

function buildImageComponent(config: PlaceholderComponent): ReactNode {
  return <img src={config.props?.src} alt={config.props?.alt || ""} style={config.props?.style} />;
}

function buildCustomComponent(config: PlaceholderComponent): ReactNode {
  return config.props?.component || null;
}

function buildPlaceholderComponent(placeholder: string, config: PlaceholderConfig): ReactNode {
  const componentConfig = config[placeholder];
  if (!componentConfig) return `{{${placeholder}}}`;

  switch (componentConfig.type) {
    case "link":
      return buildLinkComponent(componentConfig);
    case "image":
      return buildImageComponent(componentConfig);
    case "custom":
      return buildCustomComponent(componentConfig);
    default:
      return `{{${placeholder}}}`;
  }
}

export const replacePlaceholders = (text: string, config: PlaceholderConfig): ReactNode => {
  const regex = /\{\{(\w+)\}\}/g;
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }

    parts.push(buildPlaceholderComponent(match[1], config));
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.length === 0 ? (
    text
  ) : (
    <Text>
      {parts.map((part, i) => (
        <React.Fragment key={i}>{part}</React.Fragment>
      ))}
    </Text>
  );
};
